import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuContext } from '../../objects/Context';
import './Reports.css';
import { ReactComponent as ReportIcon } from '../../assets/icons/report-icon.svg';
import { ReactComponent as AnomalyIcon } from '../../assets/icons/eye-icon.svg';
import { ReactComponent as InsightsIcon } from '../../assets/icons/insights-icon.svg';
import { ReactComponent as TableIcon } from '../../assets/icons/table-icon.svg';

// ─── Static report definitions ──────────────────────────────────────────────
// Each report is a front-end-defined page.  To add a new report, add an entry
// here and create the corresponding component inside the Reports/ folder.
//
// `image` – path to a static asset in src/assets/images/reports/.
//           Set to null to show the default placeholder icon.
const REPORT_DEFINITIONS = [
  {
    id: 'overview',
    title: 'Forecast Overview',
    description: 'High-level cash flow summary',
    path: '/reports/overview',
    icon: InsightsIcon,
    themeColor: '#466391',
    // image: require('../../assets/images/reports/overview-preview.png')
    image: require('../../assets/images/overview.png'),
  },
  {
    id: 'variance',
    title: 'Variance Analysis',
    description: 'Compare actuals vs. forecast',
    path: '/reports/variance',
    icon: AnomalyIcon,
    themeColor: '#488FF3',
    // Replace with a real image path when ready, e.g.:
    // image: require('../../assets/images/reports/variance-preview.png')
    image: require('../../assets/images/variance-thumbnail.png'),
  },
  {
    id: 'transactions',
    title: 'Transactions',
    description: 'Transaction-level financial data',
    path: '/reports/transactions',
    icon: TableIcon,
    themeColor: '#36454F',
    image: require('../../assets/images/transactions.png'),
  },
];

function Reports() {
  const navigate = useNavigate();
  const { setIsMenuCondensed } = useContext(MenuContext);

  useEffect(() => {
    setIsMenuCondensed(false);
  }, []);

  return (
    <div className="wrapper reports-wrapper">
      <div className="reports-content">
        {/* Header */}
        <div className="detail-header">
          <div className="page-title-group">
            <h2>Reports</h2>
            <p className="page-subtitle">View and analyze your forecast data</p>

          </div>
        </div>

        {/* Report cards */}
        {REPORT_DEFINITIONS.length === 0 ? (
          <div className="reports-empty">
            <ReportIcon className="no-reports-icon" />
            <p>No reports found.</p>
          </div>
        ) : (
          <div id="reports-list" className="reports-list" role="list">
            <div className="reports-grid">
              {REPORT_DEFINITIONS.map((report) => {
                const IconComponent = report.icon || ReportIcon;
                return (
                  <div
                    key={report.id}
                    className="report-card"
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate(report.path)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate(report.path);
                      }
                    }}
                    aria-label={`Open ${report.title}`}
                  >
                    <div className="card-preview">
                      <div className="preview-content">
                        <div className={`preview-image-wrapper ${report.image ? '' : 'dot-pattern'}`}>
                          {report.image ? (
                            <img className="preview-image" src={report.image} alt={report.title} />
                          ) : (
                            <div className="no-preview">
                              <IconComponent className="report-icon" />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="report-details">
                      <div className="report-details-texts">
                        <h3>{report.title}</h3>
                        {report.description && (
                          <p className="timeline">{report.description}</p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Reports;
